module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image18.3aad54d7.webp";